import BulkMoveUserModal from './BulkMoveUserModal'

export default BulkMoveUserModal
